import { tagAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

import { ButtonLikePattern } from '../patterns';

// Styles
const {
  definePartsStyle,
  defineMultiStyleConfig,
} = createMultiStyleConfigHelpers(tagAnatomy.keys);

// Exports
export const Tag = defineMultiStyleConfig({
  baseStyle: definePartsStyle({
    container: ButtonLikePattern.baseStyles.static,
    closeButton: {
      ...ButtonLikePattern.baseStyles.static,
      ...ButtonLikePattern.baseStyles.interactive,
    },
  }),

  sizes: {
    sm: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.sm,
        ...ButtonLikePattern.sizes.fixedHeight.sm,
        borderRadius: '10rem',
      },
      closeButton: {
        height: '1.25rem',
        width: '1.25rem',
        marginRight: '-0.375rem',
        '> svg': { height: '0.875rem', width: '0.875rem' },
      },
    }),
    md: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.md,
        ...ButtonLikePattern.sizes.fixedHeight.md,
        borderRadius: '10rem',
      },
      closeButton: {
        height: '1.5rem',
        width: '1.5rem',
        marginRight: '-0.5rem',
        '> svg': { height: '1rem', width: '1rem' },
      },
    }),
    lg: definePartsStyle({
      container: {
        ...ButtonLikePattern.sizes.layout.lg,
        ...ButtonLikePattern.sizes.fixedHeight.lg,
        borderRadius: '10rem',
      },
      closeButton: {
        height: '1.875rem',
        width: '1.875rem',
        marginRight: '-0.75rem',
        '> svg': { height: '1.25rem', width: '1.25rem' },
      },
    }),
  },

  variants: {
    'solid-muted': definePartsStyle((props) => ({
      container: {
        ...ButtonLikePattern.variants['solid-muted'].static(props),
        /* "a&" matches the container itself if it is rendered as a link */
        'a&': ButtonLikePattern.variants['solid-muted'].interactive(props),
      },
      closeButton: {
        ...ButtonLikePattern.variants['solid-muted'].static(props),
        ...ButtonLikePattern.variants['solid-muted'].interactive(props),
      },
    })),

    'outline-muted': definePartsStyle((props) => ({
      container: {
        ...ButtonLikePattern.variants['outline-muted'].static(props),
        /* "a&" matches the container itself if it is rendered as a link */
        'a&': ButtonLikePattern.variants['outline-muted'].interactive(props),
      },
      closeButton: {
        ...ButtonLikePattern.variants.ghost.static(props),
        ...ButtonLikePattern.variants.ghost.interactive(props),
      },
    })),

    ghost: definePartsStyle((props) => ({
      container: {
        ...ButtonLikePattern.variants.ghost.static(props),
        /* "a&" matches the container itself if it is rendered as a link */
        'a&': ButtonLikePattern.variants.ghost.interactive(props),
      },
      closeButton: {
        ...ButtonLikePattern.variants.ghost.static(props),
        ...ButtonLikePattern.variants.ghost.interactive(props),
      },
    })),
  },
});

export type TagVariant = keyof NonNullable<typeof Tag['variants']>;
